// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Gestión de Vulnerabilidades?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Gestión de Vulnerabilidades es un proceso continuo de identificación, evaluación, tratamiento y reporte de vulnerabilidades de seguridad en los sistemas y el software que los ejecuta. Implica el uso de herramientas automatizadas y evaluaciones manuales para garantizar que las vulnerabilidades se aborden de manera oportuna para minimizar el riesgo de explotación.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Gestión de Vulnerabilidades
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="search"
                title="Identificación"
                description="El proceso comienza con la identificación de vulnerabilidades utilizando herramientas de escaneo automatizadas y evaluaciones manuales. Esto incluye descubrir nuevas vulnerabilidades a medida que surgen."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="assessment"
                title="Evaluación"
                description="Una vez identificadas, las vulnerabilidades se evalúan para determinar su gravedad y el impacto potencial en la organización. Esto ayuda a priorizar qué vulnerabilidades necesitan atención inmediata."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="build"
                title="Tratamiento"
                description="El tratamiento implica aplicar parches, cambios de configuración u otras acciones de remediación para abordar las vulnerabilidades identificadas. Este paso es crucial para mitigar el riesgo de explotación."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="report"
                title="Reporte"
                description="Se generan informes detallados para documentar las vulnerabilidades identificadas, su gravedad y las acciones tomadas para remediarlas. Estos informes son esenciales para el cumplimiento y las auditorías."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="update"
                title="Monitoreo Continuo"
                description="La gestión de vulnerabilidades es un proceso continuo que implica el monitoreo constante de los sistemas para detectar nuevas vulnerabilidades y asegurar que las vulnerabilidades previamente identificadas sigan mitigadas."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Gestión de Vulnerabilidades?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="security"
                title="Defensa Proactiva"
                description="La gestión de vulnerabilidades proporciona un enfoque proactivo para identificar y abordar debilidades de seguridad antes de que puedan ser explotadas por actores malintencionados."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="verified_user"
                title="Reducción de Riesgos"
                description="Al gestionar continuamente las vulnerabilidades, las organizaciones pueden reducir significativamente su riesgo de brechas de datos, pérdidas financieras y daños a la reputación."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="timer"
                title="Cumplimiento"
                description="Muchos marcos regulatorios y estándares de la industria requieren que las organizaciones implementen programas efectivos de gestión de vulnerabilidades para asegurar el cumplimiento."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="trending_up"
                title="Mejora Continua"
                description="La gestión de vulnerabilidades apoya la mejora continua de la postura de seguridad de una organización al identificar y abordar regularmente nuevas vulnerabilidades."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Gestión de Vulnerabilidades en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            La Gestión de Vulnerabilidades es un componente crítico de una estrategia integral de ciberseguridad. Ayuda a las organizaciones a mantener una defensa robusta contra un panorama de amenazas en constante evolución al identificar, evaluar y mitigar proactivamente las vulnerabilidades. Al implementar prácticas efectivas de gestión de vulnerabilidades, las organizaciones pueden proteger sus activos digitales, asegurar el cumplimiento de los requisitos regulatorios y mantener la confianza de sus clientes y partes interesadas.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;